<script setup lang="ts">
import { ref, watch } from 'vue'
import { RouterView } from 'vue-router'
import TopNavBar from '@/components/TopNavBar.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import BugReportWidget from '@/components/BugReportWidget.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'

const buildInfo = ref<string>(__APP_BUILD_TIMESTAMP__)

import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()

authStore.checkLoginStatus()

import { useDrawer } from './composables/useDrawer'
const drawer = useDrawer()

// const visible = ref<boolean>(false)

// watch for events being emitted
const toggleLoginDialog = () => {
  authStore.loginDialogVisible = !authStore.loginDialogVisible
}

watch(() => authStore.loginDialogVisible, (newValue) => {
  console.log('loginDialogVisible:', newValue)
})

</script>

<template>
  <div>
    <!-- Global components -->
    <Toast />
    <ConfirmDialog />
    
    <!-- <Button @click="visible = !visible">Show Dialog</Button> -->
    <!-- <InputText v-tooltip.top="'Enter your username'" type="text" placeholder="Top" /> -->
    <LoginDialog v-model="authStore.loginDialogVisible" />
    <TopNavBar @show-login-dialog="toggleLoginDialog" />
    <RouterView />
    <BugReportWidget />
    <Drawer
      v-model:visible="drawer.visible"
      :header="drawer.header"
      position="right"
      class="pad-drawer"
    >
      <!-- <p>
        Coherence in InSAR (Interferometric Synthetic Aperture Radar) data processing is a measure
        of how similar the radar signals are between two different observations of the same area. It
        ranges from 0 (completely different signals) to 1 (perfectly identical signals).
      </p>
      <p>
        For deformation monitoring, coherence tells us how reliable the phase difference
        (interferogram) is for measuring ground displacement. High coherence means that the surface
        properties haven’t changed much between radar acquisitions, so we can confidently extract
        deformation information. Low coherence, on the other hand, indicates changes due to
        vegetation growth, land use changes, or atmospheric noise, making deformation measurements
        less reliable.
      </p> -->
      <template v-for="(paragraph, index) in drawer.content" :key="index">
        <p class="drawer-content">{{ paragraph }}</p>
      </template>
      <Divider />
    </Drawer>
  </div>
  <!-- Use the BUILD_TIME constant -->
  <div class="bottom-line">Vite build {{ buildInfo }}</div>
</template>

<style>

@import '@/assets/base.css';

.bottom-line {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #333;
  color: white;
  /* width: 100%; */
  padding: 5px 0;
  text-align: center;
  box-sizing: border-box;
}
.bottom-line:hover {
  opacity: 0;
  transition: opacity 0.3s;
}
.pad-drawer {
  /* padding: 4%; */
  /* width: 33%; */
}
.drawer-content {
  margin-bottom: 1rem;
}
</style>
